import { render, staticRenderFns } from "./NiceManager.vue?vue&type=template&id=3eff7267&scoped=true"
import script from "./NiceManager.vue?vue&type=script&lang=js"
export * from "./NiceManager.vue?vue&type=script&lang=js"
import style0 from "./NiceManager.vue?vue&type=style&index=0&id=3eff7267&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eff7267",
  null
  
)

export default component.exports